export const Main = {
  parts: ['logo', 'sidebar', 'wrapper'],
  baseStyle: {
    logo: {
      h: '64px',
      w: '240px',
      bg: '#F0980A',
      pos: 'absolute',
      borderBottomRadius: '24px',
      top: 0,
      left: 0,
      fontSize: '32px',
      color: 'white',
      ml: 2,
    },
    sidebar: {
      w: '320px',
      bg: '#FEECB4',
      boxShadow: '-9px 0px 8px 1px rgba(73, 76, 79, 0.1)',
      fontFamily: 'Fredoka One',
      pt: 12,
    },
    wrapper: {
      w: '100%',
      h: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
    },
  },
}
